import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { login } from '../api/client'
import { ChefHat, ArrowRight } from 'lucide-react'
import toast from 'react-hot-toast'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    const form = e.currentTarget
    const emailVal = (form.elements.namedItem('email') as HTMLInputElement).value
    const passwordVal = (form.elements.namedItem('password') as HTMLInputElement).value
    setLoading(true)
    try {
      const res = await login(emailVal, passwordVal)
      localStorage.setItem('token', res.data.access_token)
      navigate('/receptek')
    } catch {
      toast.error('Hibás e-mail vagy jelszó')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex" style={{ background: '#F0FAF7' }}>

      {/* Bal panel — branding */}
      <div
        className="hidden lg:flex lg:w-1/2 flex-col justify-between p-12"
        style={{ background: '#1E2D27' }}
      >
        <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center"
               style={{ background: '#5BB8A0' }}>
            <ChefHat className="w-6 h-6 text-white" />
          </div>
          <span className="text-white font-bold text-lg">CukrászDoc</span>
        </Link>

        <div>
          <h2 className="text-4xl font-bold text-white leading-tight mb-4">
            Recept alapján —<br />
            <span style={{ color: '#5BB8A0' }}>automatikus dokumentáció.</span>
          </h2>
          <p className="text-base" style={{ color: 'rgba(255,255,255,0.55)' }}>
            Gyártmánylap, HACCP, etikett — percek alatt, nem napok alatt.
          </p>

          <div className="mt-10 space-y-4">
            {[
              'EU 1169/2011 szabványos tápértéktáblázat',
              'Allergén nyilatkozat automatikusan',
              '100×70 mm etikett PDF egy kattintással',
            ].map(f => (
              <div key={f} className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center shrink-0"
                     style={{ background: 'rgba(91,184,160,0.2)' }}>
                  <div className="w-2 h-2 rounded-full" style={{ background: '#5BB8A0' }} />
                </div>
                <span className="text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>{f}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
          © 2025 GasztroHelp · CukrászDoc
        </p>
      </div>

      {/* Jobb panel — form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">

          {/* Mobile logo */}
          <Link to="/" className="flex items-center gap-3 mb-8 lg:hidden hover:opacity-80 transition-opacity">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                 style={{ background: '#5BB8A0' }}>
              <ChefHat className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-dark-text">CukrászDoc</span>
          </Link>

          <h1 className="text-2xl font-bold mb-1" style={{ color: '#1E2D27' }}>Üdv vissza!</h1>
          <p className="text-sm text-gray-500 mb-8">Jelentkezz be a fiókodba</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">E-mail cím</label>
              <input
                className="input"
                type="email"
                name="email"
                placeholder="nev@email.hu"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div>
              <label className="label">Jelszó</label>
              <input
                className="input"
                type="password"
                name="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full mt-2"
            >
              {loading ? 'Bejelentkezés...' : (
                <>Bejelentkezés <ArrowRight className="w-4 h-4" /></>
              )}
            </button>
          </form>

          <p className="text-sm text-center text-gray-400 mt-4">
            <Link to="/forgot-password" className="hover:underline" style={{ color: '#5BB8A0' }}>
              Elfelejtett jelszó?
            </Link>
          </p>
          <p className="text-sm text-center text-gray-400 mt-3">
            Nincs még fiókod?{' '}
            <Link to="/register" className="font-semibold hover:underline" style={{ color: '#5BB8A0' }}>
              Regisztráció
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
